import _ from 'lodash';
import React from 'react';
import { WrappedFieldProps } from 'redux-form';

import { MultiSelect } from '../../../../../components/common';
import { MultiselectOption } from '../../../../../components/common/multiselect/multiselect';
import { MultiSelectTag } from '@wix/design-system';

interface OwnProps {
  dataHook: string;
  placeholder: string;
  onEnterPressed: () => void;
}

export class TeamMemberEmailsMultiselect extends React.Component<
  WrappedFieldProps & OwnProps
> {
  private optionsToTags(options: MultiselectOption[]): MultiSelectTag[] {
    return _.map(
      options,
      (option: MultiselectOption): MultiSelectTag => ({
        id: option.id,
        label: option.value as string,
      }),
    );
  }

  public render() {
    const {
      input: { onBlur, onChange, value },
      meta: { error, touched },
    } = this.props;

    return (
      <MultiSelect
        {..._.omit(this.props, ['input', 'meta'])}
        error={(touched && Boolean(error)) || undefined}
        errorMessage={error}
        onChange={onChange}
        onBlur={onBlur}
        onEnterPressed={this.props.onEnterPressed}
        tags={this.optionsToTags(value)}
      />
    );
  }
}
